import { makeStyles } from '@mui/styles';
import { colors } from '../../../colors';

export const useStyles = makeStyles({
  memberActionsWrapper: props => ({
    padding: props.showText ? '16px 0px' : '24px 16px',
    display: 'flex',
    flexDirection: props.expanded ? 'row' : 'column',
    alignItems: props.showText ? 'none' : 'center',
    justifyContent: 'center',
    gap: props.showText ? '8px' : '16px',
    marginTop: 'auto',
    width: '100%',
  }),
  actionBtn: {
    padding: 0,
    borderRadius: '4px',
    minWidth: '40px !important',
    width: '40px !important',
    height: '40px !important',
    '& svg': {
      width: '16px',
      height: '16px',
    },
    border: `1px solid ${colors?.primary200}`,
    '&:hover': {
      backgroundColor: colors?.primary25,
    },
  },
  actionBtnLabel: {
    display: 'flex',
    height: '40px !important',
    padding: '8px 12px',
    alignItems: 'center',
    gap: '4px',
    alignSelf: 'stretch',
    width: '100% !important',
    borderRadius: '4px',
    background: colors.white,
    fontFamily: 'Manrope',
    fontSize: '14px',
    minWidth: '210px !important',
    fontStyle: 'normal',
    fontWeight: 700,
    lineHeight: '20px',
    justifyContent: 'space-between',
    '& svg': {
      width: '24px',
      height: '24px',
    },
  },
});
